import React from 'react';

import { bemCssModules } from '@utils';

import { useStore } from '@modules';

import LogoutNotification from '@containers/LogoutNotification';
import LoaderLayout from '@layouts/LoaderLayout';

import Footer from './Footer';
import Header, { THeader } from './Header';

import style from './MainLayout.scss';

const cn = bemCssModules(style, 'MainLayout');

export type TMainLayout = THeader;

export const MainLayout: CustomFC<TMainLayout> = props => {
  const { children, className, backButton, closeButton, onLogoClick, isBlockedPage, isHideLinks } =
    props;

  const [{ user }] = useStore();

  const isLoading = !!user.loaders.getUserData && !user?.data;
  const headerProps = { backButton, closeButton, onLogoClick, isBlockedPage, isHideLinks };

  return (
    <div className={cn(null, [className])}>
      <LoaderLayout isLoading={isLoading}>
        <div className={cn('wrapper')}>
          <Header className={cn('header')} {...headerProps} />
          <div className={cn('content')}>
            {children}
            <LogoutNotification />
          </div>
          <Footer className={cn('footer')} />
        </div>
      </LoaderLayout>
    </div>
  );
};

export default MainLayout;
